import { action } from 'typesafe-actions';
import { ICriarTransp, ITranspSelecionada, IVerificarTransp, TransportadorasTypes } from './types';

export const loadRequestTransp = (
  inscricaoAtiva: number | undefined | any,
  cddAtivo: number | undefined
) => action(TransportadorasTypes.LOAD_REQUEST, { inscricaoAtiva, cddAtivo });

export const loadSuccessTransp = (data: ITranspSelecionada[]) =>
  action(TransportadorasTypes.LOAD_SUCCESS, { data });

export const loadFailureTransp = () => action(TransportadorasTypes.LOAD_FAILURE);

export const selectRequest = (codParceiro: number) =>
  action(TransportadorasTypes.SELECT_REQUEST, { codParceiro });

export const selectSuccess = (selecionada: ITranspSelecionada) =>
  action(TransportadorasTypes.SELECT_SUCCESS, { selecionada });

export const selectTransportadoraParceiraRequest = (codCdd: number, parceiros: number[]) =>
  action(TransportadorasTypes.SELECT_TRANSPORTADORA_PARCEIRA_REQUEST, {
    codCdd,
    parceiros,
  });

export const selectTransportadoraParceiraSuccess = (selecionada: ITranspSelecionada) =>
  action(TransportadorasTypes.SELECT_TRANSPORTADORA_PARCEIRA_SUCCESS, { selecionada });

export const criarTranspRequest = (
  inscricaoAtiva: number | undefined,
  nome: string | undefined,
  cnpj: string | undefined,
  codCid: number | undefined
) => action(TransportadorasTypes.CRIAR_TRANSPORT_REQUEST, { inscricaoAtiva, nome, cnpj, codCid });

export const criarTranspSuccess = (criarTransportadora: ICriarTransp) =>
  action(TransportadorasTypes.CRIAR_TRANSPORT_SUCCESS, { criarTransportadora });

export const criarTranspFailure = () => action(TransportadorasTypes.CRIAR_TRANSPORT_FAILURE);

export const verificarTranspRequest = () =>
  action(TransportadorasTypes.VERIFICAR_TRANSPORT_REQUEST);

export const verificarTranspSuccess = (verificarTransportadora: IVerificarTransp) =>
  action(TransportadorasTypes.VERIFICAR_TRANSPORT_SUCCESS, { verificarTransportadora });

export const verificarTranspFailure = () =>
  action(TransportadorasTypes.VERIFICAR_TRANSPORT_FAILURE);

export const cleanSelect = () => action(TransportadorasTypes.CLEAN_SELECT);

export const clearSelectTransp = () => action(TransportadorasTypes.CLEAR_TRANSP_SELECT);
